(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  /* ===========================================
     XTREME PREDICTIVE SEARCH - ULTIMATE EDITION
     ===========================================
     Performance-tuned architecture based on research:
     - Frozen empty arrays (zero GC pressure)
     - Parallel image preloading with object pooling
     - RAF-batched DOM updates for smoothness
     - Compiled regex (JIT optimized)
     - Instant cache hits (no loading flash)
     - CDN preconnect + endpoint warmup
     =========================================== */
  
  (function() {
    'use strict';
    
    // Constants - hoisted for V8 optimization
    var EMPTY = Object.freeze([]);
    var MAX_CACHE = 15;
    var MAX_PRODUCTS = 4;
    var MAX_COLS = 2;
    var MAX_ARTS = 2;
    
    // Pre-compiled regex
    var RE_SIZE = /_\d+x\d+/;
    var RE_EXT = /\.(jpg|jpeg|png|webp|gif)(\?|$)/i;
    
    // Image preloader pool (prevents GC thrashing)
    var imgPool = [];
    function getImg() { return imgPool.pop() || new Image(); }
    function freeImg(i) { if (imgPool.length < 8) { i.src = ''; imgPool.push(i); } }
    
    window.xtPredictiveSearch = function() {
      var cache, imgLoaded, ctrl, lastQ, raf;
      
      return {
        query: '',
        showResults: false,
        loading: false,
        searched: false,
        products: EMPTY,
        collections: EMPTY,
        articles: EMPTY,
        activeIndex: -1,
        
        init: function() {
          cache = new Map();
          imgLoaded = Object.create(null);
          
          var self = this;
          var form = this.$el.querySelector('.xt-search-form-desktop');
          var input = this.$el.querySelector('.xt-search-input-desktop');
          
          if (form) {
            // Block all focus styles during page load
            form.classList.add('is-loading');
            
            // Force blur any accidental focus from browser restoration
            if (input) {
              input.blur();
              input.value = '';
              self.query = '';
            }
            
            // Enable interactions after page is stable
            var enableSearch = function() {
              // Double RAF for paint stability
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  // Final blur check
                  if (input && document.activeElement === input) {
                    input.blur();
                  }
                  // Remove loading state
                  form.classList.remove('is-loading');
                });
              });
            };
            
            // Wait for full page load + small buffer
            if (document.readyState === 'complete') {
              setTimeout(enableSearch, 200);
            } else {
              window.addEventListener('load', function() {
                setTimeout(enableSearch, 200);
              }, { once: true });
            }
          }
          
          // Warmup search endpoint on idle
          var warm = function() {
            var l = document.createElement('link');
            l.rel = 'preconnect';
            l.href = 'https://cdn.shopify.com';
            l.crossOrigin = 'anonymous';
            document.head.appendChild(l);
            fetch('/search/suggest.json?q=a&resources[type]=product&resources[limit]=1',
              { priority: 'low', cache: 'force-cache' }).catch(function(){});
          };
          window.requestIdleCallback ? requestIdleCallback(warm, {timeout:2000}) : setTimeout(warm, 1000);
        },
        
        hasResults: function() {
          return this.products.length + this.collections.length + this.articles.length > 0;
        },
        
        onFocus: function() {
          var q = this.query.trim();
          if (q.length >= 2 && cache.has(q)) {
            this._instant(cache.get(q));
          } else if (this.hasResults()) {
            this.showResults = true;
          }
        },
        
        closeResults: function() {
          this.showResults = false;
          this.activeIndex = -1;
        },
        
        doSearch: function() {
          var q = this.query.trim();
          if (q === lastQ) return;
          lastQ = q;
          
          if (q.length < 2) { this._clear(); return; }
          
          // Instant cache hit
          if (cache.has(q)) { this._instant(cache.get(q)); return; }
          
          this.showResults = true;
          this.loading = true;
          this._fetch(q);
        },
        
        _fetch: function(q) {
          var self = this;
          if (ctrl) try { ctrl.abort(); } catch(e) {}
          ctrl = new AbortController();
          
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,article&resources[limit]=6', {
            signal: ctrl.signal,
            headers: { 'Accept': 'application/json' }
          })
          .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function(d) {
            if (self.query.trim() !== q) return;
            var res = d.resources && d.resources.results || {};
            var out = self._parse(res, q.toLowerCase());
            
            // LRU cache
            if (cache.size >= MAX_CACHE) cache.delete(cache.keys().next().value);
            cache.set(q, out);
            
            self._apply(out);
            self._preload(out);
          })
          .catch(function(){})
          .finally(function() { self.loading = false; });
        },
        
        _parse: function(res, qLow) {
          var self = this;
          var prods = res.products || EMPTY;
          var cols = res.collections || EMPTY;
          var arts = res.articles || EMPTY;
          var out = { products: [], collections: [], articles: [] };
          var i, p, c, a, img;
          
          for (i = 0; i < prods.length && i < MAX_PRODUCTS; i++) {
            p = prods[i];
            img = p.image || (p.featured_image && p.featured_image.url) || '';
            out.products.push({
              title: p.title,
              highlightedTitle: self._hl(p.title, qLow),
              url: p.url,
              price: self._pr(p.price),
              image: self._imgUrl(img),
              vendor: p.vendor || ''
            });
          }
          for (i = 0; i < cols.length && i < MAX_COLS; i++) {
            c = cols[i];
            img = (c.featured_image && c.featured_image.url) || c.image || '';
            out.collections.push({
              title: c.title,
              highlightedTitle: self._hl(c.title, qLow),
              url: c.url,
              image: self._imgUrl(img)
            });
          }
          for (i = 0; i < arts.length && i < MAX_ARTS; i++) {
            a = arts[i];
            img = a.image || (a.featured_image && a.featured_image.url) || '';
            out.articles.push({
              title: a.title,
              highlightedTitle: self._hl(a.title, qLow),
              url: a.url,
              image: self._imgUrl(img)
            });
          }
          return out;
        },
        
        _imgUrl: function(u) {
          if (!u || u.indexOf('cdn.shopify.com') < 0) return u || '';
          u = u.replace(RE_SIZE, '');
          var m = u.match(RE_EXT);
          return m ? u.replace('.' + m[1] + (m[2]||''), '_120x120_crop_center.' + m[1] + (m[2]||'')) : u;
        },
        
        _pr: function(p) {
          if (!p) return '';
          var n = +p;
          return n === n ? ('$' + (n === (n|0) ? n : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, ''))) : '';
        },
        
        _hl: function(t, q) {
          if (!t || !q || q.length < 2) return t || '';
          var i = t.toLowerCase().indexOf(q);
          return i < 0 ? t : t.slice(0,i) + '<mark class="xps-highlight">' + t.slice(i, i+q.length) + '</mark>' + t.slice(i+q.length);
        },
        
        _instant: function(d) {
          this.products = d.products;
          this.collections = d.collections;
          this.articles = d.articles;
          this.searched = true;
          this.showResults = true;
          this.loading = false;
        },
        
        _apply: function(d) {
          var self = this;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function() {
            self.products = d.products;
            self.collections = d.collections;
            self.articles = d.articles;
            self.searched = true;
            self.showResults = true;
            self.loading = false;
            raf = 0;
          });
        },
        
        _preload: function(d) {
          var urls = [], i;
          for (i = 0; i < d.products.length; i++) if (d.products[i].image) urls.push(d.products[i].image);
          for (i = 0; i < d.collections.length; i++) if (d.collections[i].image) urls.push(d.collections[i].image);
          for (i = 0; i < d.articles.length; i++) if (d.articles[i].image) urls.push(d.articles[i].image);
          
          // Parallel preload with pooling
          urls.forEach(function(src) {
            if (imgLoaded[src]) return;
            imgLoaded[src] = 1;
            var img = getImg();
            img.onload = img.onerror = function() { freeImg(img); };
            img.decoding = 'async';
            img.src = src;
          });
        },
        
        _clear: function() {
          this.products = EMPTY;
          this.collections = EMPTY;
          this.articles = EMPTY;
          this.searched = false;
          this.showResults = false;
          this.activeIndex = -1;
          lastQ = '';
        },
        
        navigateDown: function() {
          var t = this.products.length + this.collections.length + this.articles.length;
          if (t) this.activeIndex = (this.activeIndex + 1) % t;
        },
        
        navigateUp: function() {
          var t = this.products.length + this.collections.length + this.articles.length;
          if (t) this.activeIndex = this.activeIndex <= 0 ? t - 1 : this.activeIndex - 1;
        },
        
        handleEnter: function(e) {
          var all = this.products.concat(this.collections, this.articles);
          if (this.activeIndex >= 0 && this.activeIndex < all.length) {
            e.preventDefault();
            window.location.href = all[this.activeIndex].url;
          }
        },
        
        handleSubmit: function(e) {
          if (this.query.trim().length < 1) e.preventDefault();
        }
      };
    };
  })();

  /* Mobile Search - ULTIMATE EDITION */
  (function() {
    var EMPTY = Object.freeze([]);
    var MAX_CACHE = 12;
    var RE_SIZE = /_\d+x\d+/;
    var RE_EXT = /\.(jpg|jpeg|png|webp|gif)(\?|$)/i;
    
    window.xtMobileSearch = function() {
      var cache, ctrl, lastQ, raf;
      
      return {
        isOpen: false,
        query: '',
        loading: false,
        searched: false,
        products: EMPTY,
        
        init: function() {
          cache = new Map();
        },
        
        open: function() {
          var self = this;
          this.isOpen = true;
          document.body.style.overflow = 'hidden';
          // RAF delay for smooth animation
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              var inp = self.$refs.mobileInput;
              if (inp) inp.focus();
            });
          });
        },
        
        close: function() {
          this.isOpen = false;
          document.body.style.overflow = '';
          this.query = '';
          this.products = EMPTY;
          this.searched = false;
          lastQ = '';
        },
        
        doSearch: function() {
          var q = this.query.trim();
          if (q === lastQ) return;
          lastQ = q;
          
          if (q.length < 2) {
            this.products = EMPTY;
            this.searched = false;
            return;
          }
          
          // Instant cache hit
          if (cache.has(q)) {
            this.products = cache.get(q);
            this.searched = true;
            return;
          }
          
          if (ctrl) try { ctrl.abort(); } catch(e) {}
          ctrl = new AbortController();
          this.loading = true;
          
          var self = this;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + 
            '&resources[type]=product&resources[limit]=4', {
            signal: ctrl.signal,
            headers: { 'Accept': 'application/json' }
          })
          .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function(d) {
            if (self.query.trim() !== q) return;
            var prods = d.resources && d.resources.results && d.resources.results.products || [];
            var qLow = q.toLowerCase();
            
            var out = prods.slice(0, 4).map(function(p) {
              var n = +p.price;
              var pr = n === n ? ('$' + (n === (n|0) ? n : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, ''))) : '';
              var u = p.image || (p.featured_image && p.featured_image.url) || '';
              
              // Optimize URL
              if (u && u.indexOf('cdn.shopify.com') > -1) {
                u = u.replace(RE_SIZE, '');
                var m = u.match(RE_EXT);
                if (m) u = u.replace('.' + m[1] + (m[2]||''), '_100x100_crop_center.' + m[1] + (m[2]||''));
              }
              
              // Fast highlight
              var t = p.title, hl = t;
              var i = t.toLowerCase().indexOf(qLow);
              if (i > -1) hl = t.slice(0,i) + '<mark>' + t.slice(i, i+q.length) + '</mark>' + t.slice(i+q.length);
              
              return { title: t, url: p.url, price: pr, image: u, highlightedTitle: hl };
            });
            
            // LRU cache
            if (cache.size >= MAX_CACHE) cache.delete(cache.keys().next().value);
            cache.set(q, out);
            
            // RAF batch
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function() {
              self.products = out;
              self.searched = true;
              raf = 0;
            });
          })
          .catch(function(){})
          .finally(function() { self.loading = false; });
        },
        
        handleSubmit: function(e) {
          if (this.query.trim().length < 1) e.preventDefault();
        }
      };
    };
  })();
  
  document.addEventListener("DOMContentLoaded", function() {
    // 1. Move Drawers to Body to prevent clipping/z-index issues
    const drawerContainer = document.getElementById('xt-global-drawers');
    if (drawerContainer) {
      document.body.appendChild(drawerContainer);
    }
  });

  /* Global Drawer Functions */
  window.openDrawer = function(type) {
    const overlay = document.getElementById('xt-overlay');
    overlay.classList.add('active');
    
    if (type === 'menu') {
      document.getElementById('xt-menu-drawer').classList.add('active');
    } else if (type === 'cart') {
      document.getElementById('xt-cart-drawer').classList.add('active');
      fetchCart(); // Update cart when opening
    }
    
    // Prevent background scrolling
    document.body.style.overflow = 'hidden';
  }

  window.closeDrawers = function() {
    document.getElementById('xt-overlay').classList.remove('active');
    document.getElementById('xt-menu-drawer').classList.remove('active');
    document.getElementById('xt-cart-drawer').classList.remove('active');
    
    // Restore scrolling
    document.body.style.overflow = '';
  }

  /* AJAX Cart Logic */
  function fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => renderCart(cart))
      .catch(err => console.error('Error fetching cart:', err));
  }

  function renderCart(cart) {
    // Update Badge
    const badge = document.getElementById('xt-cart-count');
    if(badge) badge.innerText = cart.item_count;

    const container = document.getElementById('xt-cart-items-container');
    const footer = document.getElementById('xt-cart-footer');
    const totalEl = document.getElementById('xt-cart-total');

    // Format Price Helper (Simple implementation)
    const formatMoney = (cents) => {
      return '$' + (cents / 100).toFixed(2);
    };

    if (cart.item_count === 0) {
      container.innerHTML = '<div class="xt-empty-msg">Your cart is currently empty.</div>';
      footer.style.display = 'none';
    } else {
      footer.style.display = 'block';
      totalEl.innerText = formatMoney(cart.total_price);

      let html = '';
      cart.items.forEach(item => {
        html += `
          <div class="xt-cart-item">
            <img src="${item.image}" alt="${item.product_title}" class="xt-cart-img">
            <div class="xt-cart-info">
              <a href="${item.url}" class="xt-item-title">${item.product_title}</a>
              ${ item.variant_title !== null ? `<div class="xt-item-variant">${item.variant_title}</div>` : '' }
              <div class="xt-item-meta">
                <span>Qty: ${item.quantity}</span>
                <span>${formatMoney(item.line_price)}</span>
              </div>
            </div>
          </div>
        `;
      });
      container.innerHTML = html;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
